import { Api } from '../api'

const getItemCountForProject = (projectId) => {
    return Api.get(`/customers/${projectId}/item-count`);
};

const transferItems = (sourceProjectId, destinationProjectId, facilityId) => {
    const body = {
        sourceProjectId: Number(sourceProjectId),
        destinationProjectId: Number(destinationProjectId),
        facilityId: Number(facilityId)
    };

    return Api.post(`/items/transfer`, body);
};

const downloadItemImages = (sourceProjectId, facilityId) => {
    const body = {
        sourceProjectId: Number(sourceProjectId),
        facilityId: Number(facilityId)
    };

    return Api.post(`/items/imagedownload`, body);
};

export default {
    getItemCountForProject,
    transferItems,
    downloadItemImages
};